<template>
    <div>

        <p v-if="invited">
            <strong>{{ lang.polaris.account.last_invitation }}: </strong>
            {{ invited }}
        </p>
        <p v-if="loggedin">
            <strong>{{ lang.polaris.account.last_connection }}: </strong>
            {{ loggedin }}
        </p>

        <form class="trax-form pb-3" v-show="loaded">

            <!-- Account activation -->

            <trax-ui-toggle :text="lang.polaris.account.active_account" :disabled="selfEdit==1 || !canManage" v-model="active">
            </trax-ui-toggle>

            <!-- LDAP -->

            <trax-ui-toggle :text="lang.polaris.account.ldap_account" :disabled="selfEdit==1 || !canManage" v-model="ldap">
            </trax-ui-toggle>
            
        </form>

        <div v-show="active && invitation && canManage">

            <!-- Invitation button -->

            <div class="trax-form-actions text-right">
                <button type="button" class="btn btn-round btn-primary" data-toggle="modal" :data-target="'#'+id+'-send-invitation'">
                    {{ lang.polaris.account.invitation_email }}
                </button>
            </div>

            <!-- Invitation confirm modal -->

            <trax-ui-modal-confirm :id="id+'-send-invitation'" :title="lang.polaris.account.invitation_email" :bus="bus">
                {{ lang.polaris.account.confirm_invitation_email_q }}
            </trax-ui-modal-confirm>
    
        </div>
    </div>
</template>

<script>
    export default {
    
        props: {
            selfEdit: null,
            invitation: null,
        },
        
        data: function() {
            return {
                loaded: false,
                id: 'trax-account-user-edit',
                lang: lang,
                user: user,
                data: null,
                active: null,
                loggedin: '',
                invited: '',
                ldap: null,
                invite_endpoint: app_url+'polaris/api/front/users/',
                bus: this.$bus
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.bus.$on(this.id+'-send-invitation-confirmed', this.sendInvitation);
        },

        computed: {

            // The supervisors don't activate accounts and don't send invitations.
            canManage() {
                return this.user.admin || this.user.permissions['user.manage'] ? true : false;
            }
        },

        watch: {

            active: function (value) {
                if (this.loaded) this.bus.$emit(this.id+'-changed', {active: value});
            },

            ldap: function (value) {
                if (this.loaded) this.bus.$emit(this.id+'-changed', {source: value ? 'ldap' : 'internal'});
                this.loaded = true;
            }
        },

        methods: {

            setData(data) {
                this.data = data;
                this.loggedin = data.status && data.status.loggedin ? moment(data.status.loggedin).format('DD MMM YYYY') : '';
                this.invited = data.status && data.status.invited ? moment(data.status.invited).format('DD MMM YYYY') : '';
                this.active = data.active;
                this.ldap = (data.source == 'ldap');
            },

            sendInvitation() {
                var that = this;
                axios.post(this.invite_endpoint + this.data.id + '/invite')
                    .then(function (response) {
                        that.bus.$emit(that.id+'-toastr-success', response.data);
                    })
                    .catch(function (error) {
                        that.bus.$emit(that.id+'-toastr-error', error.response.data);
                    });
            }
        }
    }
</script>
